import { useCallback, useMemo } from "react";
import { MessageThreadFilesDrawerFragment } from "gql/graphql";
import {
  isAudio,
  isImage,
  isVideo,
  sortByCreateTimeDesc,
} from "modules/utils/Functions";
import { MessageThreadFilesDrawerTabType } from "modules/utils/Constants";

const useMessageThreadFilesDrawer = (
  messageThread?: MessageThreadFilesDrawerFragment | null,
) => {
  const isMedia = useCallback(
    (contentType: string) =>
      isImage(contentType) || isVideo(contentType) || isAudio(contentType),
    [],
  );

  const getFiles = useCallback(
    (tabType: MessageThreadFilesDrawerTabType) => {
      if (!messageThread) return [];
      switch (tabType) {
        case "ALL FILES":
          return [...messageThread.fileList].sort(sortByCreateTimeDesc);
        case "MEDIA":
          return [
            ...messageThread.fileList.filter((file) =>
              isMedia(file.contentType),
            ),
          ].sort(sortByCreateTimeDesc);
        case "DOCS":
          return [
            ...messageThread.fileList.filter(
              (file) => !isMedia(file.contentType),
            ),
          ].sort(sortByCreateTimeDesc);
        default:
          return [];
      }
    },
    [isMedia, messageThread],
  );

  const links = useMemo(
    () => [...(messageThread?.linkList || [])].sort(sortByCreateTimeDesc),
    [messageThread?.linkList],
  );

  return {
    getFiles,
    links,
  };
};

export default useMessageThreadFilesDrawer;
